import { ComponentType } from "react";

import { MapModelDefinitionToProps, ModelDefinition } from "./models";

export function createBlueprint<M extends BlueprintModels>(
    blueprint: Blueprint<M>
): Blueprint<M> {
    return blueprint;
}

export type Blueprint<M extends BlueprintModels = BlueprintModels> = {
    readonly models: M;
    readonly views: BlueprintViews<M>;
    readonly contentful: BlueprintContentful;
};

export type BlueprintContentful = {
    readonly spaceId: string;
};

export type BlueprintModels<T extends string = string> = {
    readonly [modelId in T]: ModelDefinition;
};

export type BlueprintViews<B extends BlueprintModels = BlueprintModels> = {
    readonly [modelId in keyof B]?: ComponentType<
        MapModelDefinitionToProps<B, modelId>
    >;
};
